import React, { useState, useEffect } from 'react';
import axios from 'axios';
import LoginPage from '../../components/LoginPage';
import SelectCompany from '../../components/SelectCompany';
import { getOpportunitiesNotifications, getOpportunityTracking, login, opportunities, opportunityTracking } from '../../utilities/urls';
import OpportunitiesList from './Opportunities';
import { enqueueSnackbar } from 'notistack';
import { Backdrop, CircularProgress } from '@mui/material';
import _ from 'lodash';
import LoadingModal from '../../components/Loading';
import messages from '../../utilities/messages';

export const EmailProcessTypes = {
  COMPANY: 'select company',
  NOTIFICATION: 'opportunity notifications',
}


function RecruitmentHelper({ name }) {
  // const [username, setUsername] = useState("");
  // const [password, setPassword] = useState("");
  // const [displayName, setDisplayName] = useState('');
  // const [email, setEmail] = useState('');
  const [frequency, setFrequency] = useState('none');
  const [isNotificationUpdated, setSuccessStatus] = useState(false);
  const [processType, setProcessType] = useState(EmailProcessTypes.COMPANY);

  const [error, setError] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false); // State to track login status
  const [availableCompanies, setAvailableCompanies] = useState([])
  const [company, setCompany] = useState('')
  const [availableOpportunities, setAvailableOpportunities] = useState([])
  // const [opportunityTrackingInfo, setOpportunityTrackingInfo] = useState([]);
  const [loading, setLoading] = useState(false);

  // const addOpportunity = () => {
  //   setOpportunityTrackingInfo([
  //     ...opportunityTrackingInfo,
  //     { opportunity: '', frequency: 'hourly', watchers: [''] },
  //   ]);
  // };

  useEffect(() => {
    const tryTheLogin = async () => {
      try {
        setLoading(true);
        if (name) {
          const response = await axios.post(login, { name });
          if (response.data.message.companies) {
            setAvailableCompanies(response.data.message.companies)
            setIsLoggedIn(true)
          }
        }
      } catch (error) {
        // setError('Error fetching jobs and processes');
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    tryTheLogin();
  }, [name]);

  // const handleSubmitOpportunities = async () => {
  //   try {/** TODO - Save these into the database */
  //     console.log(`email - ${email}`)
  //     console.log(`displayName - ${displayName}`)
  //     console.log(`opportunityTrackingInfo - ${JSON.stringify({
  //       username,
  //       password,
  //       company,
  //       email,
  //       name: displayName,
  //       opportunities: opportunityTrackingInfo,
  //     }, null, 2)}`)
  //     const response = await axios.post(opportunityTracking, {
  //       // username,
  //       // password,
  //       company,
  //       email,
  //       name: displayName,
  //       user: name,
  //       opportunities: opportunityTrackingInfo,
  //     });
  //     if (response.data.success) {
  //       alert('Opportunities submitted successfully!');
  //     } else {
  //       setError('Submission failed.');
  //     }
  //   } catch (error) {
  //     console.error('Submission failed', error);
  //     setError('An error occurred during submission.');
  //   }
  // };

  // const handleOpportunityChange = (index, key, value) => {
  //   const newOpportunities = [...opportunityTrackingInfo];
  //   newOpportunities[index][key] = value;
  //   setOpportunityTrackingInfo(newOpportunities);
  // };

  // const handleWatchersChange = (index, watcherIndex, value) => {
  //   const newOpportunities = [...opportunityTrackingInfo];
  //   newOpportunities[index].watchers[watcherIndex] = value;
  //   setOpportunityTrackingInfo(newOpportunities);
  // };

  // const addWatcher = (index) => {
  //   const newOpportunities = [...opportunityTrackingInfo];
  //   newOpportunities[index].watchers.push('');
  //   setOpportunityTrackingInfo(newOpportunities);
  // };

  // const handleCompanyClick = async (company) => {
  //   setLoading(true);
  //   try {
  //     setCompany(company);
  //     setProcessType(EmailProcessTypes.NOTIFICATION);

  //     const response = await axios.post(opportunities, { name, username, password, company });
  //     const getOpportunities = await axios.get(getOpportunitiesNotifications, { params: { name, company } });

  //     if (response.data.error || response.data.opportunities.length < 1) {
  //       setError(response.data.error); // Set error if registration fails
  //     } else {
  //       const allOpportunities = response.data.opportunities.allOpportunities;
  //       const updatedOpportunities = getOpportunities.data.length > 0 && getOpportunities.data.reduce((acc, item, index) => {
  //         const opportunityByName = _.find(allOpportunities, (o) => o.requisitionNumber === item.opportunity);

  //         if (opportunityByName) {
  //           item.title = opportunityByName.title;
  //           acc.push(item);
  //         } else {
  //           item.title = ''
  //           acc.push(item)
  //         }

  //         return acc;

  //       }, []);


  //       setAvailableOpportunities(updatedOpportunities);
  //       setEmail(response.data.opportunities.owners[0].email);
  //       setDisplayName(response.data.opportunities.owners[0].name);
  //       console.log(`Opportunities: ${response.data.opportunities}`); // Log to check the API response
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // const getOpportunities = async (company) => {
  //   try {
  //     setCompany(company);
  //     setProcessType(EmailProcessTypes.NOTIFICATION);

  //     const response = await axios.get(getOpportunitiesNotifications, { params: { name, company } });

  //     if (!response || response.data?.error) {
  //       enqueueSnackbar(response.data.error, { variant: 'error' });
  //     } else {
  //       const opportunitiesNotifications = response.data
  //       setAvailableOpportunities(opportunitiesNotifications)
  //     }

  //   } catch (error) {
  //     const errorMessage = (error.response && error.response.data.error) || error.message;
  //     enqueueSnackbar(errorMessage, { variant: 'error' });
  //   }
  // }

  const getNotificationStatus = async (company) => {
    try {
      setLoading(true);
      setCompany(company);
      setProcessType(EmailProcessTypes.NOTIFICATION);

      if (name) {
        const response = await axios.post(getOpportunityTracking, { "user": name, company });
        if (!response || response.data?.error) {
          enqueueSnackbar(response.data.error, { variant: 'error' });
        } else if (response.data.success) {
          response.data.message != null && setFrequency(response.data.message.frequency);
        }

      }
    } catch (error) {
      // setError('Error fetching jobs and processes');
      const errorMessage = (error.response && error.response.data.error) || error.message;
      enqueueSnackbar(errorMessage, { variant: 'error' });

    } finally {
      setLoading(false);
    }
  }

  const updateNotificationStatus = async (frequency) => {
    try {
      setLoading(true);

      if (name) {
        const response = await axios.post(opportunityTracking, { "user": name, company, frequency });
        if (!response || response.data?.error) {
          enqueueSnackbar(response.data.error, { variant: 'error' });
        } else {
          if (response.data.success) {
            setSuccessStatus(true);
            setTimeout(() => {
              setSuccessStatus(false);
            }, 4000);
            // enqueueSnackbar(response.data.message, { variant: 'success' });
          }
        }
      }
    } catch (error) {
      // setError('Error fetching jobs and processes');
      const errorMessage = (error.response && error.response.data.error) || error.message;
      enqueueSnackbar(errorMessage, { variant: 'error' });

    } finally {
      setLoading(false);
    }
  }

  if (!isLoggedIn || error || name === undefined) {
    return (
      <>
        <LoginPage
          headerTitle={messages.headerTitles.opportunityNotifications}
          name={name} setAvailableCompanies={setAvailableCompanies}
          setIsLoggedIn={setIsLoggedIn}
          isLoggedIn={isLoggedIn}
        />
        <LoadingModal isLoading={loading} message='Logging In...' />

      </>
    );
  }

  if ((availableCompanies && !company) || processType === EmailProcessTypes.COMPANY) {
    return (
      <>
        <SelectCompany
          headerTitle={messages.headerTitles.opportunityNotifications}
          availableCompanies={availableCompanies}
          selectedCompany={company}
          handleCompanyClick={getNotificationStatus} />
        <LoadingModal isLoading={loading} message='Fetching compaines...' />
      </>
    )
  }

  return (
    <>
      <OpportunitiesList
        setCurrentProcess={setProcessType}
        availableOpportunities={availableOpportunities}
        updateNotificationStatus={updateNotificationStatus}
        frequency={frequency}
        isNotificationUpdated={isNotificationUpdated}
        setFrequency={setFrequency}
      />
      <LoadingModal isLoading={loading} message='Getting data...' />
    </>
  )
}

export default RecruitmentHelper;
